import React, { useState } from 'react';
import { message, Switch } from 'antd';

interface Props {
  featured: boolean;
  handleChange: (status: boolean) => Promise<any>;
  successMessage?: string;
  errorMessage?: string;
}

export const FeaturedSwitch: React.FunctionComponent<Props> = ({ featured, handleChange, successMessage, errorMessage }) => {
  const [loading, setLoading] = useState(false);

  const handleFeatured = (status: boolean) => {
    setLoading(true);

    handleChange(status)
      .then(() => {
        let messageText = status ? 'Gallery is now featured!' : 'Gallery is not featured anymore!';
        if(successMessage)
          messageText = successMessage;
        message.success(successMessage);
      })
      .catch(() => {
        let errorText = errorMessage ?? 'Unable to update featured status!';
        message.error(errorText);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <label>
      <Switch onClick={handleFeatured} title="featured" checked={featured} loading={loading} />
    </label>
  );
};
